import { IIntersectionObserverOptions } from '@kurtosys/types/helpers/IntersectionObserverHelper/IIntersectionObserverOptions.js';

export class IntersectionObserverHelper {
	options: IIntersectionObserverOptions;

	constructor(options: IIntersectionObserverOptions) {
		this.options = options;
	}

	registerElements(elements: HTMLElement[]) {
		if (elements && elements.length > 0) {
			const { root, rootMargin = '0px' } = this.options;

			const options = {
				root,
				rootMargin,
				threshold: this.buildThresholdList(),
			};
			const observer = new IntersectionObserver(this.handleIntersect, options);
			for (const element of elements) {
				if (element.dataset.observed !== 'true') {
					observer.observe(element);
				}
			}
		}
	}

	buildThresholdList() {
		const thresholds = [];
		const { numSteps = 5 } = this.options;

		thresholds.push(0);

		for (let i = 1.0; i <= numSteps; i++) {
			const ratio = i / numSteps;
			thresholds.push(ratio);
		}

		return thresholds;
	}

	handleIntersect = (entries: any[], observer: any) => {
		const { callback } = this.options;

		entries.forEach((entry) => {
			const hasIntersected = entry.target.dataset.inViewport;
			if (!hasIntersected && entry.intersectionRatio > 0.2) {
				if (entry.target.dataset.observed !== 'true') {
					entry.target.dataset.observed = 'true';
					observer.unobserve(entry.target);
					if (callback) {
						callback(entry.target);
					}
				}
			}
		});
	};
}
